import { Component, OnInit, Input } from '@angular/core'
import { UserService } from '@service/user/user.service'
import { CompanyProfile } from '@model/company-profile/company-profile'
import { Title } from '@angular/platform-browser';
import { TypeService } from '@service/type.service';
import { ScrollService } from '@service/scroll.service';
import { MobileService } from '@service/mobile.service'
import { NgModule } from "@angular/core"

import { ActivatedRoute, RouterModule } from '@angular/router'
import { AboutBlockHeaderComponentModule } from '../about-block-header/about-block-header.component';
import { SharedModule } from 'src/app/shared.module';
import { ProfileHeaderComponentModule } from '../profile-header/profile-header.component';
import { StateService } from '@service/state.service';
import { BlogCardComponentModule } from '@component/generic/cards/blog-card/blog-card.component';
import { AdvertGridItemModule } from '@component/shared/advert-grid-item/advert-grid-item.component';
import { JobCardComponentModule } from '@component/generic/cards/job-card/job-card.component';

@Component({
  selector: 'app-company-profile-external',
  templateUrl: './company-profile-external.component.html',
  styleUrls: ['./company-profile-external.component.scss']
})
export class CompanyProfileExternalComponent implements OnInit {


  public loading: boolean = false

  public tabs = {
    'info': {
      name: 'Info',
      selected: false,
      filled: false,
      edit: false,
    },
    'posts': {
      name: 'Neuste Beiträge',
      selected: false,
      filled: false,
      edit: false,
    },
    'references': {
      name: 'Leistungen/Referenzen',
      selected: false,
      filled: false,
      edit: false,
    },
    'contactpersons': {
      name: 'Ansprechpartner',
      selected: false,
      filled: false,
      edit: false,
    },
    'contact': {
      name: 'Kontakt',
      selected: false,
      filled: false,
      edit: false,
    },
    'socialMedia': {
      name: 'Social Media',
      selected: false,
      filled: false,
      edit: false,
    },
  }

  public tabKeys = Object.keys(this.tabs)

  public socialMedia = {
    'facebook': {
      name: 'Facebook',
      icon: 'fab fa-facebook-square'
    },
    'instagram': {
      name: 'Instagram',
      icon: 'fab fa-instagram'
    },
    'linkedin': {
      name: 'LinkedIn',
      icon: 'fab fa-linkedin'
    },
    'xing': {
      name: 'Xing',
      icon: 'fab fa-xing-square'
    },
    'youtube': {
      name: 'Youtube',
      icon: 'fab fa-youtube'
    },
    'twitter': {
      name: 'Twitter',
      icon: 'fab fa-twitter-square'
    },
  }

  public socialMediaKeys = Object.keys(this.socialMedia)

  @Input()
  set cp(cp: CompanyProfile) {
    this._cp = cp

    this.displayStructure = cp.transformToDisplayStructure()

    // set page title
    this.title.setTitle(cp.name + ' | Zimmerer-Treffpunkt')

    // reorder tabs based on post existence
    this.tabKeys = this.reorderTabs();

    this.openFirstFilledTab()
  }

  get cp(): CompanyProfile {
    return this._cp
  }

  private _cp: CompanyProfile = null
  public displayStructure = null

  constructor(
    private userService: UserService,
    private title: Title,
    public typeService: TypeService,
    private scrollService: ScrollService,
    public MobileService: MobileService,
    public ActivatedRoute: ActivatedRoute,
    public StateService: StateService,
  ) {
    this.ActivatedRoute.params.subscribe(params => {

      this.StateService.params = params;

      this.loading = true;
      this.userService.getCompanyProfileById(params.id)
        .then((cp: CompanyProfile) => {
          this.cp = cp
        })
        .finally(() => {
          this.loading = false
        })
    })
  }

  ngOnInit() {
    this.scrollService.scrollToTop()
  }

  public selectNavItem(tabKey: string) {
    // deselect previous tab
    for (let t of this.tabKeys) {
      this.tabs[t].selected = false
    }

    this.tabs[tabKey].selected = true
  }

  private openFirstFilledTab() {
    // iterate through ordered tabKeys instead of a new displayStructure
    for (let tabKey of this.tabKeys) {
      if (this.typeService.profileObjectFilled(this.displayStructure[tabKey])) {
        this.selectNavItem(tabKey);
        return;
      }
    }
  }

  private reorderTabs(): string[] {
    const keys = Object.keys(this.tabs);
    const hasPosts = this.displayStructure && this.displayStructure['posts'] && this.displayStructure['posts'].length > 0;

    if (hasPosts) {
      return ['posts', ...keys.filter(key => key !== 'posts')];
    }

    return keys;
  }
}

@NgModule({
  declarations: [
    CompanyProfileExternalComponent,
  ],
  imports: [
    SharedModule,
    RouterModule.forChild([
      {
        path: "",
        component: CompanyProfileExternalComponent
      },
    ]),

    AboutBlockHeaderComponentModule,

    ProfileHeaderComponentModule,

    BlogCardComponentModule,
    AdvertGridItemModule,
    JobCardComponentModule,
  ],
  exports: [
    CompanyProfileExternalComponent,

    SharedModule,

    AboutBlockHeaderComponentModule,
    ProfileHeaderComponentModule,
  ]
})
export class CompanyProfileExternalComponentModule { }